module.exports = __webpack_public_path__ + "img/left-pics.877c215d.png";